// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] + "." + {"506":"7e64dc47","536":"7d3eb842","889":"efb6fb0c"}[chunkId] + ".js";
};